export let KycApplicationType;
(function (KycApplicationType) {
  KycApplicationType["native"] = "native";
  KycApplicationType["stripe"] = "stripe";
})(KycApplicationType || (KycApplicationType = {}));